import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/services/global.service';
import { formatNumber, Location } from '@angular/common';
import { TenantService } from 'src/app/tenant/tenant.service';
import { AuthService } from '../account/auth.service';
import { AppService } from 'src/app/shared/services/app.service';

@Component({
    selector: 'app-switch-tenant',
    templateUrl: './switch-tenant.component.html',
    styleUrls: ['./switch-tenant.component.scss'],
    standalone: false
})
export class SwitchTenantComponent implements OnInit {
  isLoading: boolean = true;
  UnknownTenant: boolean = false;
  SwitchingChurch: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private globalService: GlobalService,
    private router: Router, 
    private route: ActivatedRoute,
    private authService: AuthService,
    private tenantService: TenantService,
    private appService: AppService
  ) { }

  ngOnInit(): void {
    this.isLoading = false; 
  }

  async onSubmit(form: NgForm) {
    if (!form.valid || form.value.churchId.trim() == '') {
      return;
    }
    this.SwitchingChurch = true;
    var tenant = form.value.churchId.toLowerCase().trim();
    if (await this.tenantService.tenantExists(tenant) == false)
    {
      this.UnknownTenant = true;
      this.SwitchingChurch = false;
      return;
    }

    this.clearAllCache();
    this.authService.logout(0);
    var userId = localStorage.getItem("CSBarCodeID");
    if (userId == null)
      userId = "";
    localStorage.setItem('tenant', tenant);
    this.appService.sendToNative(userId, tenant);
    let currentUrl = this.document.location.origin.toLowerCase().replace(this.globalService.subdomain.toLowerCase(), 
    'main') + '/' + tenant.toLowerCase() + '/home';
    this.globalService.subdomain = tenant;
    location.href = currentUrl;   
  }

  clearAllCache()
  {
    caches.keys().then(cacheNames => {
      cacheNames.forEach(cacheName => {
        caches.delete(cacheName);
      });
    });
  }
}  

